// The always-visible "who you are right now" chip. One tap opens the
// "Who's racing?" chooser. Shows a gentle prompt when no profile is active yet
// (e.g. a guest, or before anyone has created one).
import type { LocalProfile } from "../lib/profile";

export default function ProfileChip({
  profile,
  onClick,
}: {
  profile: LocalProfile | null;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className="coin-badge max-w-[60vw] px-2.5 py-1.5 text-base hover:border-flame"
      onClick={onClick}
      aria-label={
        profile ? `Racing as ${profile.displayName} — switch racer` : "Choose a racer"
      }
      title="Who's racing?"
    >
      <span className="text-xl leading-none" aria-hidden>
        {profile?.avatar || "🙂"}
      </span>
      <span className="min-w-0 truncate font-bold text-ink">
        {profile ? profile.displayName : "Choose racer"}
      </span>
      <span className="text-ink/40" aria-hidden>
        ▾
      </span>
    </button>
  );
}
